<template>
  <td>{{ question.questionEn }}</td>
  <td>{{ question.questionCh }}</td>
  <td>{{ question.answerEn }}</td>
  <td>{{ question.answerCh }}</td>
  <td>
    <BootstrapIcon
      class="listTableIcon"
      icon="pencil-square"
      @click="showEdit()"
    />
    <BootstrapIcon
      class="listTableIcon  delete"
      icon="trash"
      @click="deleteItem(question._id)"
    />
  </td>
  <ModalFaqEdit
    :question="question"
    v-if="displayEdit"
    @close-modal-event="hideEdit"
  ></ModalFaqEdit>
</template>
<script>
import axios from "axios";
import authHeader from "../../services/authHeader";
import ModalFaqEdit from "./ModalFaqEdit.vue";
export default {
  name: "AdminFaqTable",
  props: {
    question: Object,
  },
  components: {
    ModalFaqEdit,
  },
  data() {
    return {
      displayEdit: false,
    };
  },
  methods: {
    deleteItem(id) {
      axios
        .delete(this.$webDomain + "/garden/GardenQuestion", {
          headers: authHeader(),
          data: {
            itemId: id,
          },
        })
        .then(function(response) {
          console.log(response);
          window.location.reload();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    showEdit() {
      this.displayEdit = true;
      console.log(this.question);
    },
    hideEdit() {
      this.displayEdit = false;
    },
  },
};
</script>
